import { render, staticRenderFns } from "./cabnet-doctor.vue?vue&type=template&id=26a08516&"
import script from "./cabnet-doctor.vue?vue&type=script&lang=js&"
export * from "./cabnet-doctor.vue?vue&type=script&lang=js&"
import style0 from "./cabnet-doctor.vue?vue&type=style&index=0&id=26a08516&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports